
export function required(value) {
  return (!value && value !== 0)
}

export function stringLength(value, length) {
  return value.split(' ').length >= length
}

export function validName(value) {
  return (value && /^[A-Za-z ]+$/i.test(value))
}

export function validFullName(value) {
  const hasOneWord = value && value.split(' ').length >= 2
  const validLastName = hasOneWord && value.split(' ')[1] ? value.split(' ')[1].length === 0 : true

  return value && validLastName
}

export function validPhone(value) {
  return (value && /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/.test(value)) // eslint-disable-line max-len
}

export function validUUID(value) {
  return (value && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)) // eslint-disable-line max-len
}

export function validEmail(value) {
  return (value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))
}

export function validUrl(value) {
  return (!value || !/https?:\/\/?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/i.test(value))
}

export function validSlug(value) {
  return (!value || !/^[a-z0-9]+(?:-)$/.test(value))
}

export function validMoney(value) {
  return (value && !/^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/i.test(value))
}

export function validNumber(value) {
  return (value && !/^([0-9]+)$/i.test(value))
}

export function passwordIsInvalid(value) {
  return value.length < 8
  /*  let hasSmallCase = false
    let hasUpperCase = false
    let hasDigits = false
    let score = 0

    for (let i = 0, len = value.length, ch; i < len; ++i) {
      ch = value.charAt(i)

      if (ch.match(/^[0-9]+$/)) {
        hasDigits = true
      }

      if (ch === ch.toUpperCase() && ch.match(/^[a-zA-Z]+$/)) {
        hasUpperCase = true
      }

      if (ch === ch.toLowerCase() && ch.match(/^[a-zA-Z]+$/)) {
        hasSmallCase = true
      }
    }

    if (value.length >= 8) {
      score += 1
    }

    if (hasDigits) {
      score += 1
    }

    if (hasUpperCase && hasSmallCase) {
      score += 1
    }

    return score < 3*/
}

export function samePassword(value1, value2) {
  return (value1 !== value2)
}

export function numberRange(min, max, value) {
  const v = parseInt(value, 10)
  return ((v >= min && v <= max))
}

export function ipAddress(value) {
  return (value && /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value)) // eslint-disable-line max-len
}

export function withinMinLength(length, value) {
  return !(value.length < length)
}

export function withinMaxLength(length, value) {
  return !(value.length > length)
}

export function exactLength(length, value) {
  return value.length !== length
}

export function lengthInRange(min, max, value) {
  return (value.length >= min && value.length <= max)
}

export function coordinate(value) {
  const isValidCoord = /^\s*-?\d+\.\d+$/.test(value)
  return (!isValidCoord)
}



// WEBPACK FOOTER //
// ./src/utils/validation.js